import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSubject = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4 7.5V5.5H20V7.5H4ZM4 9.5H20V11.5H4V9.5ZM4 17.5H14V19.5H4V17.5ZM4 15.5H20V13.5H4V15.5Z",
			fill: "#2771bb"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0",
			"mask-type": "alpha",
			maskUnits: "userSpaceOnUse",
			x: 4,
			y: 5,
			width: 16,
			height: 15,
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M4 7.5V5.5H20V7.5H4ZM4 9.5H20V11.5H4V9.5ZM4 17.5H14V19.5H4V17.5ZM4 15.5H20V13.5H4V15.5Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", { mask: "url(#mask0)" })
	]
});
const ForwardRef = forwardRef(SvgSubject);
export default ForwardRef;
